import React from "react";
import { Rating, RatingProps, IconContainerProps } from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";

export interface IMxRatingFieldProps extends RatingProps {
  label?: string;
  error?: boolean;
  helperText?: string;
}

const customIcons: {
  [index: string]: {
    icon: React.ReactElement;
    label: string;
  };
} = {
  1: {
    icon: <SentimentSatisfiedAltIcon color="success" fontSize="large" />,
    label: "Satisfecho"
  },
  2: {
    icon: <SentimentSatisfiedIcon color="warning" fontSize="large" />,
    label: "Neutral"
  },
  3: {
    icon: <SentimentVeryDissatisfiedIcon color="error" fontSize="large" />,
    label: "Insatisfecho"
  },
  4: {
    icon: <></>,
    label: ""
  },
  5: {
    icon: <></>,
    label: ""
  }
};

function IconContainer(props: IconContainerProps) {
  const { value, ...other } = props;
  return (
    <ContainerEmotions className="icon-s">
      <span {...other}>{customIcons[value].icon}</span>
      <CustomSpan {...other}>{customIcons[value].label}</CustomSpan>
    </ContainerEmotions>
  );
}

const MxRatingField = (props: IMxRatingFieldProps) => {
  const { helperText, error, ...ratingProps } = props;

  return (
    <Container data-testid={`${props.id || props.name}-rating-field`}>
      <StyledRating
        {...ratingProps}
        IconContainerComponent={IconContainer}
        getLabelText={(value: number) => customIcons[value].label}
        highlightSelectedOnly
        max={3}
        data-testid={`${props.id || props.name}-rating`}
      />
      {helperText && (
        <HelperText
          error={error}
          data-testid={`${props.id || props.name}-helper-text`}
        >
          {helperText}
        </HelperText>
      )}
    </Container>
  );
};

export default MxRatingField;

// Styled Components

const Container = muiStyled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px"
}));

const StyledRating = muiStyled(Rating)(({ theme }) => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: theme.palette.action.disabled
  }
}));

const ContainerEmotions = muiStyled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  minWidth: "75px",
  alignItems: "center"
}));

const CustomSpan = muiStyled("span")(({ theme }) => ({
  fontSize: "10px",
  color: theme.palette.text.primary
}));

const HelperText = muiStyled("span")<{ error?: boolean }>(({ theme, error }) => ({
  fontSize: "12px",
  color: error ? theme.palette.error.main : theme.palette.text.secondary,
  textAlign: "center"
}));
